var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 560.2 560.2",
    style: {
      enableBackground: "new 0 0 560.2 560.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.7,0c154.7,0,280.5,125.8,280.5,280.5S434.4,560.2,279.7,560.2S0,435.2,0,280.5S125,0,279.7,0z  M281.2,321.1l89.1,89.8c11,11,28.9,11,39.9,0c10.1-10.1,10.1-28.1,0-39.1L321.1,282l89.1-89.8c10.1-10.9,10.1-28.9,0-39.1 c-10.9-10.9-28.9-10.9-39.9,0L281.2,243l-89.1-89.8c-10.9-10.9-28.9-10.9-39.8,0c-10.2,10.1-10.2,28.1,0,39.1l89.1,89.8l-89.1,89.9 c-10.2,10.9-10.2,28.9,0,39.1c10.9,11,28.9,11,39.8,0L281.2,321.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.58682c1df00f7ed314927404c023c17b.svg";
export { ForwardRef as ReactComponent };